import { toIcalStringDate } from '../../../../neb-input/nebFormatUtils';

const _buildDetailsSection = (info, appointmentLink) => {
  const link = encodeURIComponent(appointmentLink);
  return `For more information, or to update your appointment, please visit: <a href="${link}">here</a>.`;
};

const _buildLocationAddress = location =>
  [
    location.address1,
    ...(location.address2 ? [location.address2] : []),
    location.city,
    location.state,
    location.zipCode,
  ].join(', ');

export const createGoogleCalendarEvent = (
  appointment,
  tenantPracticeInfo,
  provider,
  location,
  appointmentLink,
) => {
  const practiceName =
    location && location.name
      ? `${tenantPracticeInfo.name} - ${location.name}`
      : `${tenantPracticeInfo.name}`;

  const summary = `${practiceName}, ${
    appointment.serviceName || appointment.appointmentTypeName
  } (${provider})`;

  const uri = [];
  uri.push('https://www.google.com/calendar/render?action=TEMPLATE');
  uri.push(`text=${summary}`);
  uri.push(
    `dates=${toIcalStringDate(new Date(appointment.start))}/${toIcalStringDate(
      new Date(appointment.end),
    )}`,
  );

  uri.push(
    `details=${_buildDetailsSection(tenantPracticeInfo, appointmentLink)}`,
  );

  uri.push(
    `location=${_buildLocationAddress(location || tenantPracticeInfo.address)}`,
  );

  window.open(uri.join('&'), '_blank');
};
